<template>
    <section>
        <div>
            <div class="is-pulled-right is-size-7">
                Inference requests in the last 30 days
            </div>
            <h2 class="title is-4">
                <b-icon icon="chart-line" size="is-small"></b-icon>
                Inference Monitor
            </h2>

            <apexchart v-if="series" type="line" height="220" :options="options" :series="series"></apexchart>

            <b-field grouped group-multiline>

                <div class="control">
                    <b-dropdown @active-change="changeLabels" v-model="selectedLabels" multiple aria-role="list">
                        <template #trigger="{ active }">
                            <b-button :icon-right="active ? 'caret-up' : 'caret-down'">
                            Predictions ({{ selectedLabels.length }})
                            </b-button>
                        </template>
                    <b-dropdown-item v-for="(option, index) in dropdownOptions" :key="index" :value="option.label" aria-role="listitem">
                        <span>{{ option.label }}</span>
                    </b-dropdown-item>
                    </b-dropdown>
                </div>

                <div class="control">
                    <b-dropdown @active-change="changeIsRecorded" v-model="selectedIsRecorded" aria-role="list">
                        <template #trigger="{ active }">
                            <b-button @change.native="changeIsRecorded" :icon-right="active ? 'caret-up' : 'caret-down'">
                            Log_recorded: {{ selectedIsRecorded }}
                            </b-button>
                        </template>
                    <b-dropdown-item aria-role="listitem" value="True">"Yes"</b-dropdown-item>
                    <b-dropdown-item aria-role="listitem" value="False">"No"</b-dropdown-item>
                    </b-dropdown>
                </div>

                <div class="control">
                    <b-field>
                            <b-select
                                @change.native="changeSignal"
                                v-model="selectedSignal"
                                placeholder="Confidence Higher/Lower:"
                                >
                                <option value=">">Higher than</option>
                                <option value="<">Lower than</option>
                            </b-select>
                    </b-field>
                </div>

                <div class="control">
                    <div style="width: 150px;">
                        <b-slider @change="onSliderChange" :value="25" size="is-medium" :tooltip="true" v-model="sliderValue" lazy >
                                    <b-slider-tick :value="0">0</b-slider-tick>
                                    <b-slider-tick :value="25">25</b-slider-tick>
                                    <b-slider-tick :value="50">50</b-slider-tick>
                                    <b-slider-tick :value="75">75</b-slider-tick>
                                    <b-slider-tick :value="99">99</b-slider-tick>
                        </b-slider>
                    </div>
                </div>

                <div class="control">
                    <b-button
                        @click="addRecords"
                        class="button vertical-center"
                        type="is-light"
                        :disabled="checkedRows.length === 0"
                        style="font-size:16px"
                    >
                    <span class="icon">
                        <i class="fa fa-plus"></i>
                    </span>
                    &nbsp; Add to training ({{ checkedRows.length }})
                    </b-button>
                </div>

            </b-field>

            <b-table
                :data="logs_data"
                :row-class="(row, index) => row "
                :loading="loading"
                :checked-rows.sync="checkedRows"
                checkable

                paginated
                backend-pagination
                :total="total"
                :per-page="perPage"
                @page-change="onPageChange"
                aria-next-label="Next page"
                aria-previous-label="Previous page"
                aria-page-label="Page"
                aria-current-label="Current page"
            >

                <b-table-column
                    width="100%"
                    field="createdAt"
                    custom-key="createdAt"
                    v-slot="props"
                >
                    <Logs :row="props.row" :project="project" />
                
                </b-table-column>
            </b-table>
        </div>
    </section>
</template>
<script>

import Logs from "@/dashboard/Project/Logs.vue";
   export default {
     props: ["project"],
     name: "DeployMonitor",
     data() {
        return {
            logs_data: [],
            logs_resume: [],
            page: 1,
            total: 20,
            perPage: 50,
            defaultSortDirection: 'desc',
            checkboxCustom: 'Yes',
            daysN: 7,
            recordsCount: 0,
            checkboxPosition: 'left',
            checkboxType: 'is-primary',
            selectedLabels: [],
            selectedConfidence: "",
            selectedIsRecorded: "",
            dropdownOptions: this.project.labels,
            projectLabels: [],
            loading: false,
            options: null,
            series: null,
            value1: 0,
            sliderValue: 50,
            selectedSignal: null,
            checkedRows: [],
            isActive: false,
            nextToken: [{ page: 1, lk: "" }]
        }
    },
    components: {
        Logs
    },
    computed: {},
     filters: {
        formatDate: function (value) {
            if (!value) return ''
            return new Date(value*1000).toLocaleString()
        },
     },
     methods: {
        formattedValue() {
            return `${this.selectedSignal || ">"} ${(this.sliderValue / 100).toFixed(2)}`;
        },
        loadAsyncData() {

                let nextItemPage = this.getNextToken(this.page)
                let score = this.formattedValue()

                const payload = {   model_id: this.project.id, 
                                    page_size: this.perPage,
                                    predictions: this.selectedLabels,
                                    score: score,
                                    is_recorded: this.selectedIsRecorded,
                                    next_token: nextItemPage, }

                this.loading = true
                this.$store.dispatch("getLogsByModel", payload)
                    .then(( logs_data ) => {
                        this.logs_data = []

                        logs_data[0].forEach((item) => {
                            this.logs_data.push(item)
                        })

                        let nextToken = logs_data[1] || {};
                        let count = logs_data[2]
                        
                        if (this.page === 1) {
                            this.nextToken.push({ page: this.page + 1, lk: nextToken });

                            this.total = count
                        }

                        if (Object.keys(nextToken).length === 0) {
                            this.total = this.page * this.perPage
                        }

                        if (Object.keys(nextToken).length > 0 && this.page > 1){
                            this.nextToken.push({ page: this.page + 1, lk: nextToken });
                        }

                        this.loading = false
                    
                })
                .catch((error) => {
                        this.logs_data = []
                        this.total = 0
                        this.loading = false
                        throw error
                    })

        },
        logsResume() {
            this.$store.dispatch("getLogsResumeByModel", this.project.id)
                .then(( logs_resume ) => {

                    this.logs_resume = logs_resume

                    let date = logs_resume.date
                    let requests = logs_resume.requests
        
                    this.options = {
                        chart: {
                            id: 'reqs-plot'
                        },
                        xaxis: {
                            categories: date
                        }
                    }

                    this.series = [{
                        name: "requests",
                        data: requests
                    }]
                })
        },
        getNextToken(page) {
            
            let nextItemPage = this.nextToken[0].lk

            if (page > 1){

                let index = this.nextToken.findIndex(item => item.page === this.page);
                return this.nextToken[index].lk;

            }

            return nextItemPage;

        },
        onPageChange(page) {
            this.page = page;

            this.loadAsyncData();
        },
        changeLabels () {

            this.loadAsyncData();

        },
        changeIsRecorded () {

            this.loadAsyncData();
        },
        changeSignal() {

            this.loadAsyncData();            
        },
        onSliderChange(){

            this.loadAsyncData();
        },
        getDatesLast30Days() {
            const today = new Date();
            const dates = [];

            for (let i = 0; i < 30; i++) {
                const date = new Date(today);
                date.setDate(today.getDate() - i);
                dates.push(date.toISOString().split('T')[0]); // Format as YYYY-MM-DD
            }

            return dates.reverse()
        },
        formatValue(val) {
          return `${val}%`;
        },
        notificationMessage(){

            this.$buefy.snackbar.open({
            duration: 3000,
            queue: true,
            message: `<b>Your data has been recorded to your training dataset. </b><br>Count: ${this.checkedRows.length}...`,
            type: "is-white",
            position: "is-bottom-left",
            pauseOnHover: true,
            actionText: "Cancel",
            queue: true,

          });

        },
        addRecords() {


            // Iterate over each checked row
            this.checkedRows.forEach(row => {
            // Extract predictions and confidences
            let predictions = row.responseBody.predictions.map(prediction => ({label: prediction.label}));
            let confidences = row.responseBody.predictions.map(prediction => prediction.score);

            // Create a new object with the required structure
            const record = {
                text: row.text,
                prediction: predictions,
                confidence: confidences,
                labels: predictions,
                projectId: this.project.id
            };

            let flag_update = {
                uid: row.uid,
                apiKey: row.apiKey,
                fields: {
                    is_recorded: true
                }

            }

            this.$store.dispatch("updateLogsRecord", flag_update)
            // Push the new object to the pipeline API - addRecord
            this.$store.dispatch("addRecord", record)

            this.recordsCount = this.checkedRows.length
            this.isActive = true

            //notification message
            this.notificationMessage()

            if (this.checkedRows.length === 0){
                this.loadAsyncData()
            }

            //cleaning checkedRows variable
            this.checkedRows = []
            });
        }
     },
     watch: { },
     mounted(){
        let mock_dates = this.getDatesLast30Days()
        this.options = {
            chart: {
                id: 'reqs-plot'
            },
            xaxis: {
                categories: mock_dates
            }
        }
        this.series = [{
            name: "requests",
            data: Array.from({ length: mock_dates.length }, () => 0)
        }]

        this.loadAsyncData()
        this.logsResume()

     }
        
}
</script>

<style scoped>

.box {
    display: -webkit-box;
    width: 100%;
}


.boards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;

  .board {
    cursor: pointer;
    border: solid 1px #e6e4e4;
    border-radius: 4px;

    &:hover {
      background: #fafafa;
    }

    .info {
      padding: 16px;

      .name {
        display: block;
        margin-bottom: 8px;
        text-transform: capitalize;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      .description {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        margin: 0;
        margin-bottom: 8px;
        overflow: hidden;
      }
    }
  }
}


</style>